import * as React from 'react';
import PropTypes from 'prop-types';
import UpgradeDialog from './UpgradeDialog';

export const UpgradeServiceContext = React.createContext(Promise.reject);

export const useUpgrade = () => React.useContext(UpgradeServiceContext);

export const UpgradeServiceProvider = ({ children }) => {
  const [upgradeState, setUpgradeState] = React.useState(null);

  const awaitingPromiseRef = React.useRef();

  const openUpgrade = options => {
    setUpgradeState({ open: true });
    return new Promise((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (upgradeState.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }
    setUpgradeState(null);
  };

  const handleSubmit = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }
    setUpgradeState(null);
  };

  return (
    <UpgradeServiceContext.Provider value={openUpgrade}>
      {children}
      <UpgradeDialog
        open={Boolean(upgradeState)}
        onUpgrade={handleSubmit}
        onCancel={handleClose}
        {...upgradeState}
      />
    </UpgradeServiceContext.Provider>
  );
};
UpgradeServiceContext.propTypes = {
  children: PropTypes.node
};
